<template>
  <input-base
    :class="getClass"
    stretched
    transparent>

    <label
      class="input-label"
      slot="label">

      {{ $t(getLabel) }}
    </label>

    <div slot="input">
      <vue-dropzone
        @vdropzone-sending="sendingEvent"
        @vdropzone-complete="fileUploadAttempted"
        @vdropzone-success="checkFileResponseStatus"
        @vdropzone-thumbnail="generateThumbnail"

        @vdropzone-files-added="filesChanged"
        @vdropzone-file-added-manually="filesChanged"
        @vdropzone-removed-file="filesChanged"

        ref="mediaDropzone"
        class="dropzone-target"
        :options="dropzoneOptions"
        :id="inputName"
        :url="dropzoneOptions.url" />

      <div
        v-if="!noMedia"
        class="gif-search">

        <input-button
          class="mt-3"
          variant="standardInput"
          :inputPlaceholder="$t('Search.gifsPlaceholder')"
          btnStyle="ok-style"
          hollow
          smaller
          stretched
          @click="popupGifs()" />


        <input-text
          v-if="gifsPrompted"
          class="search-text-box"
          variant="standardInput"
          inputName="giphySearch"
          :inputPlaceholder="$t('Search.gifsPlaceholder')"
          stretched
          small
          @fieldUpdate="setGifQuery" />

        <gif-display
          v-if="gifsPrompted"
          :loading="gifsLoading"
          :gifs="gifs"
          @closeGifs="closeGifs"
          @selectGif="selectGif"
          @newGifPage="newGifPage" />

      </div>
    </div>
  </input-base>
</template>

<script>
import GifDisplay from '@/components/standard/display/GifDisplay'
import InputText from '@/components/standard/input/InputText'
import InputButton from '@/components/standard/input/InputButton'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import gql from 'graphql-tag'
import apolloSetup from '@/assets/modules/apollo/apolloSetup'
import localStorageHelper from '@/assets/modules/localStorageHelper'
import objectHelpers from '@/assets/modules/objectHelpers'
import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import apiConnector from '@/mixins/apiConnector'
import InputBase from '@/components/standard/input/InputBase'

import uuidv1 from 'uuid/v1'
import loadImage from 'blueimp-load-image'

const mime = require('mime-types')
import resolver from '@/assets/modules/error/resolver'
import manager from '@/assets/modules/notifications/manager'
let GphApiClient = require('giphy-js-sdk-core')

const MAX_THUMBNAIL = { width: 200, height: 200 }

let vmRef = null

  export default {
    components: {
      'gif-display': GifDisplay,
      'input-text': InputText,
      'input-button': InputButton,
      'vue-dropzone': vue2Dropzone,
      'input-base': InputBase
    },
    data () {
      vmRef = this
      let client = GphApiClient(process.env.GIPHY_KEY)
      return {
        componentTearDown: false,

        currentFileIndex: 0,

        imageRefType: 'advertisable',
        imageRef: null,
        imageId: null,

        gifSearchString: null,
        gifs: [],
        selectedGifs: {},
        client,
        gifsPrompted: false,

        usedImages: {},

        gifsLoading: false,

        gifPage: 0,
        gifLimit: 10,

        imgName: null,
        imgData: null,

        dropzoneClearing: false,

        clearCallback: null,
        clearParams: null,
        totalFiles: 0,
        filesProcessed: 0,

        self: this,
        dropzoneOptions: {
          timeout: -1,
          dictDefaultMessage: this.getDropzoneMessage(),
          url: this.getRequestedEndpoint(),

          autoProcessQueue: false,
          addRemoveLinks: true,
          maxFilesize: 200,
          parallelUploads: 1000,
          headers: {
            'Accept': '',
            'Cache-Control': '',
            'X-Requested-With': '',
          },

          init: function() {
            // @description When file removal is attempted; if file
            // has not been uploaded do nothing, otherwise mutate API.
            this.on("addedfile",(file) => {
              
              // If files type is not given attempt a type guess
              let { type } = file
              type = mime.lookup(file.name) || type || '*/*'
              console.log("DEBUG ::")
              console.error(file)
              console.error(type)
              console.error(vmRef.expectedType)

              if (!vmRef.matchMimeType(type)) {
                vmRef.$refs['mediaDropzone'].dropzone.removeFile(file);
                vmRef.$emit('dropzoneError', {
                  message: 'DropZone.wrongFiletype'
                })
                return false
              }

              vmRef.fileChange()
            }),

            this.on("removedfile",(file) => {
              if (!vmRef.localRemove && !vmRef.componentTearDown && (file.manuallyAdded || file.upload.progress === 100) && !this.dropzoneClearing) {
                
                let {mutationString, dataObject, name} = fieldBuilder
                  .buildGqlObject(file, 'deleteMedia', 'mutation', [])

                let okCallback = (e) => {
                  console.log('Image deleted!')
                  console.log(e)
                }

                let failCallback = (_, e) => {
                  console.error('Image failed to delete')
                  console.error(e)
                }

                vmRef.sendMutation(mutationString,
                  dataObject,
                  okCallback,
                  failCallback,
                  name)
              }

              // Remove from gifs as well
              delete vmRef.selectedGifs[file.dataURL]
            }),

            this.on("success",(file, response, status) => {
              try {
                file.id = response.data[0].Id
              } catch (e) {
                console.error(e)
              }
            })
          }
        }
      }
    },
    beforeDestroy () {
      this.componentTearDown = true
    },
    methods: {
      /**
       * Emits event that files have changed
       */
      filesChanged () {
        this.$emit('fileChange', {})
      },

      /**
       * Called when preview thumbnail for given file is generated. Use loadImage to correct
       * orientation
       * @param {Object} file
       */
      generateThumbnail (file) {
        // Don't do this for gifs
        if (file.previewElement && mime.lookup(file.dataURL) !== 'image/gif') {
          // Find node that has preview image...
          let image
          let i = 0
          for (let i = 0; i < file.previewElement.children.length; i++) {
            let el = file.previewElement.children.item(i)
            if (el.className === 'dz-image') image = el; break
          }

          let width, height
          width = Math.min(MAX_THUMBNAIL.width, file.width || Number.MAX_VALUE)
          height = Math.min(MAX_THUMBNAIL.height, file.height || Number.MAX_VALUE)

          // Add a spinner while file is loading...
          image.innerHTML = `
            <div
              class="thumbnail-spinner"
              style="min-width: ${width}px; min-height: ${height}px">

              <i class="fas fa-spinner fa-spin"></i>
            </div>
          `

          // Create an image with EXIF orientation included
          // loadImage returns a canvas node with rotated image, that is than appended where
          // image preview is supposed to be
          let self = this
          loadImage(
            file.dataURL,
            (img) => {
              image.innerHTML = ''
              if (img && img.type !== 'error') {
                image.appendChild(img)

                // When file preview generates; emit update...
                this.filesChanged()
              } else {
                image.innerHTML = 'x'
              }
            },
            {
              maxWidth: width,
              maxHeight: height,
              orientation: true,
              canvas: true,
              downsamplingRatio: 0.5,
              pixelRatio: 0.5
            }
          )
        }
      },

      popupGifs () {
        this.gifsPrompted = true
      },

      /**
       * Check if user has dropped apropriate file based on it's mime type
       * @param {String} type Tested mime type
       * @returns {Boolean} If the tested mime type matches the expected type
       */
      matchMimeType(type) {
        let expectedType = this.getMimeType
        // If no type specified; Use it
        if (expectedType === null || expectedType.type === '*') return true

        type = type.split('/')
        if (expectedType.type === type[0]) {
          if (expectedType.subType === '*') return true
          // Not allowing all subtypes so this one will fail.
          if (type.length === 1) return false

          return expectedType.subType === type[1]
        }

        return false
      },

      fileChange (e) {
        if (this.onFilePick !== null) {
          ((this.onFilePick)(e, this))
        }
      },

      /**
       * Checks if all files have been uploaded. If yes, run the clear callback
       */
      checkUploadStatus () {
        // If there are any more files to be proccessed
        if (this.filesProcessed < this.totalFiles) return false
        this.runClearCallback()
      },

      /**
       * Runs the clear callback method
       */
      runClearCallback () {
        // Do the clearCallback function
        if (!!this.clearCallback) {
          if (this.clearParams) {
            ((this.clearCallback)(...this.clearParams, this))
          } else {
            ((this.clearCallback)(this))
          }

          this.clearCallback = null
          this.clearParams = null
        }
      },

      /**
       * Will check files status
       * @param {Object} file
       * @param {Object} response
       */
      checkFileResponseStatus (file, response) {
        if (response.errors && response.errors.length > 0){
          console.error(response)
          let { errors } = response

          let message = 'Nalaganje datoteke je spodletelo.'
          message = resolver.resolve(errors[0].message, message)
          manager.nokNotification(this, message)
        }
      },

      /**
       * Called if either the file was uploaded successfully or the upload has 
       * failed.
       */
      fileUploadAttempted () {
        this.filesProcessed ++

        this.checkUploadStatus()
      },

      setClearCallback (clearCallback, clearParams) {
        this.clearCallback = clearCallback
        this.clearParams = clearParams
      },

      clearFiles () {
        this.clearImages()
      },

      clearImages () {
        this.filesProcessed = 0
        this.totalFiles = 0

        let allFiles = this.getAllFiles()
        this.dropzoneClearing = true

        for (let file of allFiles) {
          this.$refs['mediaDropzone'].dropzone.removeFile(file)
        }

        this.$set(this, 'selectedGifs', {})

        this.dropzoneClearing = false
      },

      getAllFiles () {
        return this.$refs['mediaDropzone'].dropzone.files
      },

      getAllUploadedFiles () {
        let allFiles = this.getAllFiles()
        let rtr = []
        for (let f of allFiles) {
          if (f.xhr) {
            let { response } = f.xhr
            if (response) {
              response = JSON.parse(response)
              response = response.data.pop() || {}
  
              rtr.push({
                uuid: f.upload.uuid,
                url: response.Url
              })
            }
          } else if (f.manuallyAdded) {
            rtr.push({
              uuid: f.upload.uuid,
              url: f.dataURL
            })
          }
        }

        return rtr
      },

      processImages (refType = null, fefId = null, imgId = null, reupload = false) {
        this.imageRefType = refType
        this.imageRef = fefId
        this.imageId = imgId

        this.totalFiles = this.getAllFiles().length
        this.filesProcessed = 0
        
        let okCallback = (e) => {
          this.fileUploadAttempted()
        }

        let failCallback = (_, e) => {
          let message = 'Nalaganje datoteke je spodletelo.'
          message = resolver.resolve(e.message, message)
          manager.nokNotification(this, message)
        }

        // Store already uploaded files - Dropzone won't reupload.
        let files = this.$refs['mediaDropzone'].dropzone.files

        // If no files are pressent, finish 
        if (!files.length) {
          this.fileUploadAttempted()
          return
        }

        // Check how manny manualy added files are already uploaded
        if (!reupload) {
          for (let f of files) {
            if (f.manuallyAdded && f.uploaded) {
              this.fileUploadAttempted()
            }
          }
        }

        // // Set manualy added files as not uploaded
        // for (let f of files) {
        //   if (f.manuallyAdded) {
        //     f.uploaded = false
        //   }
        // }

        // Upload gifs as well.
        let mutateFiles = []
        if (reupload) {
          mutateFiles = [...mutateFiles, ...this.$refs['mediaDropzone'].dropzone.getRejectedFiles().filter(f => f.manuallyAdded && f.uploaded)]
        }

        mutateFiles = [...mutateFiles, ...Object.values(this.selectedGifs)]

        for (let mf of mutateFiles) {
          let bo = {
            refType: this.imageRefType,
            ref: this.imageRef,
            remoteUrl: mf.dataURL,
            async: false
          }

          let {mutationString, dataObject, name} = fieldBuilder
            .buildGqlObject(bo, 'storeMedia', 'mutation', [])

          this.sendMutation(mutationString,
            dataObject,
            okCallback,
            failCallback,
            name)
        }

        this.currentFileIndex = 0
        // Process user added files
        this.$refs['mediaDropzone'].dropzone.processQueue()
      },

      sendingEvent (file, xhr, formData) {
        if (this.imageRef !== null) {
          formData.append(`file_ref_0`, this.imageRef)
        }

        if (this.imageRefType !== null) {
          formData.append(`file_ref_type_0`, this.imageRefType)
        }

        if (this.imageId !== null) {
          formData.append(`file_id_0`, this.imageId)
        }

        formData.append(`file_ref_order_0`, this.currentFileIndex)

        formData.append(`file_0`, `@${file.name}`)
        this.currentFileIndex++
      },

      newGifPage (e) {
        this.fetchGifs(this.gifSearchString)
      },
      setGifQuery (e) {
        this.gifs = []
        this.gifSearchString = e.value
        this.fetchGifs(this.gifSearchString)
      },
      selectGif (e) {
        let gif = e.gif
        let mockFile = {
          name: gif.title,
          size: gif.images.downsized.gif_size,
          dataURL: gif.images.downsized.gif_url,
          type: 'image/gif',
          upload: {
            uuid: uuidv1()
          }
        }

        let url = gif.images.downsized.gif_url

        this.$refs['mediaDropzone'].manuallyAddFile(mockFile, url)
        this.$set(this.selectedGifs, url, { dataURL: url })
        this.closeGifs({close: true})
      },

      closeGifs (e) {
        if (e.close) {
          this.gifsPrompted = false
        }
      },
      fetchGifs (filters) {
        this.gifsLoading = true

        let self = this

        this.client.search('gifs', {"q": filters, "limit": this.getGifLimit, "offset": this.getGifOffset})
          .then((response) => {
            self.gifs = self.gifs.concat(response.data)
            self.gifPage++
            self.gifsLoading = false
          })
          .catch((err) => {

        })
      },

      redoQuery () {
        this.$apollo.queries.advertisables.refresh()
      },

      /**
       * Gives dropzone's message
       * @returns {String}
       */
      getDropzoneMessage () {
        return this.inputPlaceholder || `<i class="fas fa-cloud-upload-alt green"></i>`
      },

      getRequestedEndpoint () {
        return `${process.env[this.endpoint]}?jwt=${localStorageHelper.getData('user', 'token')}`
      }
    },
    computed: {
      /**
       * Gives dropzone's placeholder
       * @returns {String}
       */
      getLabel () {
        return this.inputLabel || 'Placeholder.file.image'
      },

      /**
       * Returns expected mimetype
       * @returns {Object} Expected mimetype
       */
      getMimeType () {
        return this.expectedType
      },

      getGifLimit () {
        return this.gifLimit
      },
      getGifOffset () {
        return this.gifPage * this.getGifLimit
      },

      getClass () {
        let base = `image-upload`
        return `${base} ${this.className}`
      }
    },
    props: {
      expectedType: {
        type: Object,
        required: false,
        default: null
      },

      endpoint: {
        type: String,
        required: false,
        default: 'IMG_UPLOAD'
      },

      noMedia: {
        type: Boolean,
        required: false,
        default: false
      },

      onFilePick: {
        required: false,
        default: null
      },

      localRemove: {
        type: Boolean,
        required: false,
        default: false
      },

      images: {
        type: Array,
        required: false,
        default: () => []
      },
      className: {
        type: String,
        required: false
      },
      inputName: {
        type: String,
        required: true
      },
      inputPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      inputLabel: {
        type: String,
        required: false,
        default: ''
      }
    },
    mixins: [
      apiConnector
    ],

    watch: {
      images: {
        // When API has sent a response of resolved shop type
        handler: function(newValue) {
          for (let img of newValue) {
            let {url, filesize, id, type} = img

            // If mime type is not provided, guess it
            if (!type) {
              type = mime.lookup(url) || '*/*'
            }

            if (!this.usedImages[url]) {
              let mockFile = {
                dataURL: url,
                name: url,
                dataURL: url,
                size: filesize,
                id,
                type,
                uploaded: true,
                upload: {
                  uuid: id
                }
              }

              this.$refs['mediaDropzone'].manuallyAddFile(mockFile, url)
              this.$set(this.usedImages, url, true)
            }
          }
        },
        deep: true
      }
    },
  }
</script>
<style>
.dz-preview, .dropzone-target, .image-upload {
  z-index: 1!important;
  border-color: #D2D3D4!important;
  border-width: 1px;
  border-radius: 4px;
}
.dz-preview.dz-image-preview .dz-image {
  min-width: 200px;
  min-height: 200px;
  display: flex!important;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.full {
  width: 100%;
}
.dz-default.dz-message {
  color: #7ac143;
  font-size: 300%;
  margin: 0;
  display: block!important;
}

.dropzone-target.vue-dropzone.dropzone.dz-clickable {
  /* Overwrite default dropzone min-height */
  min-height: 100px!important;
}

.dropzone-target.vue-dropzone.dropzone .dz-default.dz-message {
  margin: 0!important;
}

</style>

<style scoped>
.image-upload {
  padding-top: 12px;
  padding-bottom: 12px;
}

.gif-search .search-text-box {
  margin-bottom: 5px!important;
  z-index: 10000000;
  width: 275px;
}

.input-label {
  font-size: 13px;
  font-weight: bold;
  color: #757575;
}

@media (max-width: 768px) {
  .gif-search .search-text-box {
    width: 100%;
  }
}

</style>

<style>
.dz-preview.dz-image-preview .dz-image .thumbnail-spinner {
  padding-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/standard/input/InputImage.vue?174d72f0